
(function (fox, $) {
	'use strict';
	
	fox.registerWidget('Cancellation_Offer_Popup', {
		configure() {
			this.registerOptions('', {
				onOkPress: (...args) => this.resubscribe(...args),
				onCancelPress: (...args) => this.onCancel(...args),
				contentTemplate: 'cancellation_offer_popup',
				widgets: {
					actionPopup: {
						widget: 'Cancellation_Action'
					},
					form: {
						widget: 'DomForm',
						formSelector: '#form-discount'
					}
				}
			});
			this.callParent('configure', arguments);
		},

		resubscribe(el, w, a, e) {
			const actionPopup = this.wom1('#actionPopup');
			const sendApi = this.getApi('etentionPolicy', {
				method: 'retentionPolicy.resubscribe'
			});
			const form = this.rwom1('#form');
			el.classList.add('spin');
			return form.submit().then((values) => {
				if (values === false) {
					return null;
				}
				return sendApi.psend(values).then((resp) => {
					this.hide();
					return actionPopup.show('cancellation_success_popup')
						.then(() => true);
				}).catch((err) => {
					console.log(err);
					this.hide();
					return actionPopup.show('cancellation_error_popup')
						.then(() => true);
				});
			});
		}
	}, 'GDPR_BasePopup');
	

})(fox, fox.jQuery);


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/cancellation/widget/cancellation-offer-popup.es.js